<template>
    <div class="backtest-once">
       <label>
            <input type="text" v-model="onceKeyWord" placeholder="搜索关键词" @keyup.enter="updateSearchOnce">
            <span @click="updateSearchOnce"></span>
        </label>
        <div class="list">
            <p v-show="isSearchResult && !isFromSearch">
                <span>你还没有创建任何策略哦~</span><br>
                <router-link :to="'/backtest'">
                    <span class="created">立即创建我的策略</span>
                </router-link>
            </p>
            <p v-show="isSearchResult && isFromSearch">暂无查询列表数据</p>
            <vue-loading v-show="isshowloading" style="height: calc(100% - 20px);border:none;top:0;left:0"></vue-loading>
            <div class="list-item" v-for="(item, index) in onceDataList" :key="index" v-show="!isSearchResult && !isshowloading">
                <div class="item">
                    <div class="item-report_level" :class="item.report_level | levelType">
                    </div>
                    <div class="item-details">
                        <router-link :to="{path: 'backtest', query: parseQuery(item)}"><p @click="buriedPoints">{{ item.query }}</p></router-link>
                        <span class="start-time"><b>开始时间:</b>{{item.start_time}}</span>
                        <span><b>结束时间:</b>{{item.end_time}}</span>
                        <span class="ctime">{{item.ctime}}</span>
                    </div>
                    <div class="item-rate">
                        <p :class="item.average_income | riseAndFallClass">{{item.average_income | safePercentFixedTwo}}</p>
                        <span>单次涨跌幅平均值</span>
                    </div>
                    <div class="item-rate">
                        <p :class="item.win_rate | riseAndFallClass">{{item.win_rate | safePercentFixedTwo}}</p>
                        <span>上涨概览</span>
                    </div>
                    <div class="item-hold_period">
                        <p>{{item.hold_period}}</p>
                        <span>持有期</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="pagination-heart">
            <vue-pagination
                class="square-page"
                :page-size="pageSize"
                :total="total"
                @current-change="goPage">
            </vue-pagination>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'backtest-once',
        data () {
            return {
                onceKeyWord: '',
                currentPage: 1,
                pageSize: 10,
                sort: 'ctime',
                order: 'DESC',
                isshowloading: false,
                isFromSearch: true,
                isSearchResult: false
            }
        },
        computed: {
            buriedPoint () {
                return this.$buriedPoint.myStrategy.createdStrategy
            },
            backtestOnceData () {
                return this.$store.getters['myStrategy/backtestOnceData']
            },
            onceDataList () {
                return this.backtestOnceData.list
            },
            total () {
                return this.backtestOnceData.num
            }
        },
        methods: {
            buriedPoints () {
                window.TA.log(this.buriedPoint.inBacktestOnce)
            },
            goPage (page) {
                window.TA.log(this.buriedPoint.backtestOncePage)
                this.currentPage = page
            },
            updateList () {
                var self = this
                this.isshowloading = true
                this.isSearchResult = false
                this.$store.dispatch('myStrategy/requestBacktestOnce', {
                    keyword: this.onceKeyWord,
                    page: this.currentPage,
                    pagesize: this.pageSize,
                    sort: this.sort,
                    order: this.order
                }).then((result) => {
                    self.isshowloading = false
                    if (self.onceDataList.length === 0) {
                        self.isFromSearch = Boolean(self.onceKeyWord)
                        self.isSearchResult = true
                    } else {
                        self.isSearchResult = false
                    }
                }).catch((error) => {
                    self.isshowloading = false
                    self.$tip({message: error ? error.message : '网络异常', type: 'error'})
                })
            },
            updateSearchOnce () {
                window.TA.log(this.buriedPoint.search)
                this.updateList()
            },
            parseQuery (item) {
                return {
                    endDate: item.end_time,
                    startDate: item.start_time,
                    daysForSaleStrategy: item.days_for_sale,
                    query: item.query,
                    benchmark: item.benchmark
                }
            }
        },
        created () {
            this.updateList()
        },
        watch: {
            currentPage () {
                this.updateList()
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    @import '../../scss/mystrategy/backtest-once.scss';
</style>



// WEBPACK FOOTER //
// src/components/mystrategy/backtest-once.vue